import { FC } from 'react'

import { Spinner as SpinnerComponent, Stack } from '@forto-dev/phoenix-ui-core/common'
import { Splash } from '@forto-dev/phoenix-ui-core/ship'

export const Spinner: FC = () => {
  return (
    <Splash>
      <Stack x="center">
        <SpinnerComponent size="lg" />
      </Stack>
    </Splash>
  )
}
